import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getPaletteAsRawColors } from 'owa-theme';
import { ITheme } from '@fluentui/react/lib/Styling';
import { themeFromColorScheme } from 'owa-color-utils/lib/colorUtils';

export default function (colorScheme: ColorScheme, isDarkTheme?: boolean): ITheme {
    const calendarTheme = themeFromColorScheme(colorScheme);
    const neutralSecondary = getPaletteAsRawColors(null, isDarkTheme).neutralSecondary;
    const neutralDark = getPaletteAsRawColors(null, isDarkTheme).neutralDark;
    return {
        ...calendarTheme,
        semanticColors: {
            ...calendarTheme.semanticColors,
            smallInputBorder: neutralSecondary,
            inputBorderHovered: neutralDark,
        },
    };
}
